import { timeKeyForMinute } from './timelineLogic.js';

export const SPECTRUM_SORT_WIN_R18 = 'win_r18';
export const SPECTRUM_SORT_WIN = 'win';

export function getLatestOvernightTimeKey(horse) {
  const keys = Object.keys(horse?.time_series || {})
    .filter((key) => {
      const minute = parseInt(String(key).split('_')[1], 10);
      return !Number.isNaN(minute) && minute > 720;
    })
    .sort((a, b) => parseInt(b.split('_')[1], 10) - parseInt(a.split('_')[1], 10));
  return keys[0] || null;
}

/** 频谱/柱图排序用赔率：独前=win_r18，独赢=当前视图分钟 win_odds */
export function getHorseSpectrumSortOdds(horse, sortBy, options = {}) {
  const { viewMinute = -1, overnightActive = false } = options;
  if (sortBy === SPECTRUM_SORT_WIN_R18) {
    const v = Number(horse?.odds?.win_r18);
    return Number.isFinite(v) && v > 0 ? v : 999;
  }
  let ts = null;
  if (overnightActive) {
    const key = getLatestOvernightTimeKey(horse);
    ts = key ? horse?.time_series?.[key] : null;
  } else {
    const tk = timeKeyForMinute(viewMinute);
    ts = horse?.time_series?.[tk];
  }
  const fromTs = Number(ts?.win_odds);
  if (Number.isFinite(fromTs) && fromTs > 0) return fromTs;
  const fromOdds = Number(horse?.odds?.win);
  if (Number.isFinite(fromOdds) && fromOdds > 0) return fromOdds;
  const fallback = Number(horse?.odds?.win_r18);
  return Number.isFinite(fallback) && fallback > 0 ? fallback : 999;
}

/** 按 sortBy 对应赔率升序（独前=热码在前；不按名次置顶） */
export function sortHorsesForSpectrum(horses, sortBy, options = {}) {
  const list = Array.isArray(horses) ? horses : [];
  return [...list].sort((a, b) => {
    const aOdds = getHorseSpectrumSortOdds(a, sortBy, options);
    const bOdds = getHorseSpectrumSortOdds(b, sortBy, options);
    return aOdds - bOdds;
  });
}
